export const seoTools = [
  {
    name: "OneShot Learning Masterclass",
    slug: "oneshot-masterclass",
    description: "Turn any textbook chapter or syllabus topic into a structured 20-minute video lesson with modulewise visual explanations and practice Q&A.",
    icon: "GraduationCap"
  },
  {
    name: "Study From Your Materials",
    slug: "study-from-materials",
    description: "Upload textbook PDFs, class notes, or exam syllabus to generate personalized AI video masterclasses and smart study notes.",
    icon: "UploadCloud"
  },
  {
    name: "AI Doubt Solver",
    slug: "ai-doubt-solver",
    description: "Scan, upload, or type any complex educational doubt and get instant step-by-step visual AI explanations.",
    icon: "BrainCircuit"
  },
  {
    name: "Smart Notes & Formula Generator",
    slug: "smart-notes-generator",
    description: "Generates real-time formula sheets, diagram summaries, key concepts, and topic breakdowns.",
    icon: "Layers"
  },
  {
    name: "Mock Test Practice",
    slug: "mock-test-practice",
    description: "Generate customized exam-focused practice tests for JEE, NEET, GATE, CBSE, and Engineering.",
    icon: "BookOpen"
  },
  {
    name: "Rank Predictor",
    slug: "rank-predictor",
    description: "Calculate your expected rank based on past year cutoffs and expected percentiles.",
    icon: "PieChart"
  }
];

